import { jsx as _jsx } from "react/jsx-runtime";
import { BifIconInformationCircle, OverlayTrigger, Popover } from "banafo-design-system";
import { Trans } from "react-i18next";
const FtpInfoMessage = () => {
    return (_jsx("span", { onClick: (e) => { e.stopPropagation(); }, className: "d-inline-flex me-25", children: _jsx(OverlayTrigger, { trigger: 'click', placement: "top", rootClose: true, delay: { show: 250, hide: 0 }, overlay: _jsx(Popover, { children: _jsx(Popover.Body, { children: _jsx("small", { className: "form-text", children: _jsx(Trans, { i18nKey: "infos:Ftp.info.text_" }) }) }) }), children: _jsx(BifIconInformationCircle, { className: "text-warning" }) }) }));
};
export default FtpInfoMessage;
